exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-margin[data-v-5598780a]{margin-left:18px}.radios[data-v-5598780a]{margin:.2rem}", ""]);

// exports
